<app-top-navigation></app-top-navigation>
<div class="width-100">
    <div class="page-container">
       <ng-content></ng-content>
    </div>
</div>
